import { render, staticRenderFns } from "./upgrade-goods.vue?vue&type=template&id=72cf4b9e&scoped=true&"
import script from "./upgrade-goods.vue?vue&type=script&lang=js&"
export * from "./upgrade-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cf4b9e",
  null
  
)

export default component.exports